module.exports = __webpack_public_path__ + "static/media/go.e9a03fe8.svg";